import { create } from 'zustand';

/** A focus move the month grid carries out once the target month is on screen. */
export interface PendingMonthFocus {
  readonly date: string;
  /** Also move the DOM focus to the day cell (keyboard moves); false only moves the tab stop. */
  readonly focusDom: boolean;
}

interface MonthUiState {
  /** The grid's roving tab stop; null while the month view is not shown. */
  readonly focusedDate: string | null;
  readonly pending: PendingMonthFocus | null;
  setFocusedDate: (date: string | null) => void;
  /** Ask the grid to focus `date` as soon as its month is shown (it may be another month). */
  requestFocus: (date: string, focusDom: boolean) => void;
  clearPending: () => void;
}

/** Month-view focus state, shared with the top bar and the global shortcuts (2026-10b §9.6, §10.2). */
export const useMonthUi = create<MonthUiState>((set) => ({
  focusedDate: null,
  pending: null,
  setFocusedDate: (date) => set({ focusedDate: date }),
  requestFocus: (date, focusDom) => set({ pending: { date, focusDom } }),
  clearPending: () => set({ pending: null }),
}));
